module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.45689e1c.webp";